import React from 'react';

function Skill({title = "title", prc = 80, imgUrl = "", href=""}){
	return (
		<div className='skill'>
			<div className='skill-title'>
				<img src={imgUrl}></img>
				<a href={href} target='_blank'>
					{title}
				</a>
			</div>
			<div className='skill-bar'>
				<div className='skill-bar-fill' style={{scale: `${prc}% 100%`}}></div>
			</div>
			<p className='skill-prc'>{prc}%</p>
		</div>
	)
}

function Talents({visible, wasVisible, isMobile}){
	const visibility = !visible && visible == wasVisible ? "hidden" : "visible";
	const ratio = window.innerHeight / window.innerWidth;
	return (
		<>
			<div className="top-left pointer-none" style={{visibility}}>
				<div className='skills pointer-all' style={{opacity: visible ? 1 : 0}}>
					<h1 className='marginless'>My Skills</h1>
					{(visible || wasVisible) && (<>
						<Skill title="JavaScript" prc={95} imgUrl='./javascript.svg' href='https://www.javascript.com/'/>
						<Skill title="C#" prc={85} imgUrl='./csharp.svg' href='https://learn.microsoft.com/en-us/dotnet/csharp/'/>
						<Skill title="ReactJS" prc={70} imgUrl='./react.svg' href='https://react.dev/'/>
						<Skill title="NodeJS" prc={85} imgUrl='./nodejs.svg' href='https://nodejs.org/'/>
					</>)}
				</div>
			</div>

			<div className={(isMobile ? "top-right" : "bottom-left") + " "} style={{visibility}}>
				<div className='skills' style={{opacity: visible ? 1 : 0}}>
					<p className='pointer-none'>I also have experience with:</p>
					<div className='other-skills'>
						<div className='box'><a href='https://www.java.com/' target='_blank'><img src='./java.svg'></img></a></div>
						<div className='box'><a href='https://www.python.org/' target='_blank'><img src='./python.svg'></img></a></div>
						<div className='box'><a href='https://www.php.net/' target='_blank'><img src='./php.svg'></img></a></div>
						<div className='box'><a href='https://www.w3.org/Style/CSS/' target='_blank'><img src='./css.svg'></img></a></div>
						<div className='box'><a href='https://sass-lang.com/' target='_blank'><img src='./sass.svg'></img></a></div>
						<div className='box'><a href='https://jquery.com/' target='_blank'><img src='./jquery.svg'></img></a></div>
						<div className='box'><a href='https://unity.com/' target='_blank'><img src='./unity.svg'></img></a></div>
						<div className='box'><a href='https://laravel.com/' target='_blank'><img src='./laravel.svg'></img></a></div>
						<div className='box'><a href='https://www.mongodb.com/' target='_blank'><img src='./mongodb.svg'></img></a></div>
						<div className='box'><a href='https://www.mysql.com/' target='_blank'><img src='./mysql.svg'></img></a></div>
					</div>
				</div>
			</div>

			<div className={"bottom-right pointer-none"} style={{visibility}}>
				<div className={(ratio > 1.55 ? "big" : "") + ' talents'} style={{opacity: visible ? 1 : 0}}>
					<h1 className='marginless'>My Talents</h1>
					<ul style={{marginBottom: "25px"}}>
						<li>
							I can speak Russian, English<br/> and Latvian
						</li>
						<li>
							Good at problem solving
						</li>
						<li>
							Good at fixing others' bugs
						</li>
						<li>
							I'm patient
						</li>
						<li>
							Good at concentrating
						</li>
						<li>
							Logical thinking
						</li>
						<li>
							Smart, fair and caring
						</li>
					</ul>
				</div>
			</div>
		</>
	)
}

export default Talents;